import {DataSourceInterface} from './datasource.interface.mjs';
import * as plugins from "@mecatran/utils";
import {model} from "./belfortsig/schema.mjs";

var { Geojson } = model;

var {request} = plugins;

export class BelfortSigDataSource extends DataSourceInterface{
    constructor(belfortGeojsonSigConfig){
        super();
        var _config = belfortGeojsonSigConfig;

        Object.defineProperty(this,'config',{
            get : function(){ return _config }
        });

        this.setSchema(Geojson);
    }

    fetchData(){
        var url = this.config.getUrl();
        var headers = { accept : 'application/json' };
        //var headers = { method:'GET', accept : '*/*'};
        var promise = new Promise((resolve,reject)=>{
            function callback(error,response,body){
                // console.log('body',body)
                if (error) reject(error);
                else resolve(body)
            }
            request({url,headers}, callback);
        });
        return promise;       
    }

    transformer(data){
        return (data.features)
    }
}

